export default {
  level: 'Level',
  total: 'Total',
  planLevel: 'Plan Level',
  quantityOf: 'Quantity of',
  definition: 'Definition',
  description: 'Description',
}
